import {
    watch,
    type ComputedRef,
    type WritableComputedRef,
    onMounted,
    type Ref,
    type ShallowRef,
} from 'vue'
import { useCarousel } from '@/components/layout/carousels/base/useCarouselNew'
import type { GalleryWithEnquiryCardFragment } from '@/graphql/api'

export interface ComponentGalleryWithEnquiryMobile {
    containerMobile: Ref<HTMLElement | null, HTMLElement | null>
    itemElsMobile: Readonly<ShallowRef<HTMLDivElement[] | null>>
    previousMobile: () => void
    nextMobile: () => void
}

export function useComponentGalleryWithEnquiryMobile(
    isMobile: ComputedRef<boolean>,
    items: Readonly<Ref<GalleryWithEnquiryCardFragment[]>>,
    currentItem: WritableComputedRef<
        GalleryWithEnquiryCardFragment | undefined
    >,
    currentItemIndex: ComputedRef<number>
): ComponentGalleryWithEnquiryMobile {
    const {
        container: containerMobile,
        elements: itemElsMobile,
        current: currentMobileElIndex,
        previous: previousMobile,
        next: nextMobile,
    } = useCarousel(items)

    watch(currentMobileElIndex, (newCurrent) => {
        currentItem.value = items.value[newCurrent]
    })

    onMounted(() => {
        if (!isMobile.value) {
            return
        }

        const index = currentItemIndex.value

        if (index !== -1) {
            currentMobileElIndex.value = index
        }
    })

    return {
        containerMobile,
        itemElsMobile,
        previousMobile,
        nextMobile,
    }
}
